import React, { useState } from 'react';
import { Search, SlidersHorizontal, X } from 'lucide-react';
import Header from './components/Header1';
import Footer from './components/Footer1';
import ProductCard from './components/ProductCard';
import Button from './components/Button';

const Shop = () => {
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [sortBy, setSortBy] = useState('featured');
    const [showFilters, setShowFilters] = useState(false);
    const [priceRange, setPriceRange] = useState([0, 50000]);

    const categories = ['All', 'Sarees', 'Lehengas', 'Kurtas', 'Accessories'];
    const sortOptions = [
        { value: 'featured', label: 'Featured' },
        { value: 'price-low', label: 'Price: Low to High' },
        { value: 'price-high', label: 'Price: High to Low' },
        { value: 'newest', label: 'Newest' },
    ];

    const products = [
        { id: 1, name: 'Chanderi Silk Saree', category: 'Sarees', price: 8999, image: 'https://images.pexels.com/photos/2916387/pexels-photo-2916387.jpeg?auto=compress&cs=tinysrgb&w=600' },
        { id: 2, name: 'Banarasi Brocade Lehenga', category: 'Lehengas', price: 24999, originalPrice: 29999, image: 'https://images.pexels.com/photos/3224610/pexels-photo-3224610.jpeg?auto=compress&cs=tinysrgb&w=600' },
        { id: 3, name: 'Embroidered Anarkali Kurta', category: 'Kurtas', price: 5499, image: 'https://images.pexels.com/photos/2220316/pexels-photo-2220316.jpeg?auto=compress&cs=tinysrgb&w=600' },
        { id: 4, name: 'Kundan Jewellery Set', category: 'Accessories', price: 3299, image: 'https://images.pexels.com/photos/2955819/pexels-photo-2955819.jpeg?auto=compress&cs=tinysrgb&w=600' },
        { id: 5, name: 'Organza Printed Saree', category: 'Sarees', price: 6799, image: 'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=600' },
        { id: 6, name: 'Velvet Bridal Lehenga', category: 'Lehengas', price: 32999, image: 'https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=600' },
        { id: 7, name: 'Cotton Chikankari Kurta', category: 'Kurtas', price: 2999, image: 'https://images.pexels.com/photos/3014853/pexels-photo-3014853.jpeg?auto=compress&cs=tinysrgb&w=600' },
        { id: 8, name: 'Oxidised Silver Jhumkas', category: 'Accessories', price: 1499, originalPrice: 1999, image: 'https://images.pexels.com/photos/2955375/pexels-photo-2955375.jpeg?auto=compress&cs=tinysrgb&w=600' },
        { id: 9, name: 'Kanjivaram Silk Saree', category: 'Sarees', price: 18999, image: 'https://images.pexels.com/photos/4614070/pexels-photo-4614070.jpeg?auto=compress&cs=tinysrgb&w=600' },
        { id: 10, name: 'Georgette Sharara Set', category: 'Lehengas', price: 12499, image: 'https://images.pexels.com/photos/6712360/pexels-photo-6712360.jpeg?auto=compress&cs=tinysrgb&w=600' },
        { id: 11, name: 'Mirror Work Kurta Set', category: 'Kurtas', price: 4299, image: 'https://images.pexels.com/photos/7275385/pexels-photo-7275385.jpeg?auto=compress&cs=tinysrgb&w=600' },
        { id: 12, name: 'Pearl Maang Tikka', category: 'Accessories', price: 2199, image: 'https://images.pexels.com/photos/8953474/pexels-photo-8953474.jpeg?auto=compress&cs=tinysrgb&w=600' },
    ];

    const filteredProducts = selectedCategory === 'all'
        ? products
        : products.filter(p => p.category.toLowerCase() === selectedCategory.toLowerCase());

    return (
        <div className="min-h-screen bg-white" style={{ fontFamily: "'Poppins', sans-serif" }}>
            <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
            <Header cartCount={3} />

            <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-10 lg:py-12">
                {/* Page Header */}
                <div className="mb-6 md:mb-10">
                    <p className="text-xs md:text-sm tracking-[0.3em] uppercase text-[#2D6A4F] mb-1 font-medium">Curated for You</p>
                    <h1 className="text-2xl md:text-4xl lg:text-5xl font-semibold text-[#1A1A1A] mb-2">Our Collection</h1>
                    <p className="text-sm md:text-base text-[#6B7280]">Discover handcrafted ethnic wear that celebrates Indian heritage</p>
                </div>

                {/* Search and Filter Bar */}
                <div className="flex flex-col md:flex-row gap-3 mb-6 md:mb-8">
                    <div className="flex-1 relative">
                        <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-[#9CA3AF]" size={18} />
                        <input
                            type="text"
                            placeholder="Search products..."
                            className="w-full pl-11 pr-4 py-2.5 md:py-3 border border-[#E5E7EB] bg-white text-sm focus:outline-none focus:border-[#2D6A4F] transition-colors"
                        />
                    </div>
                    <select
                        value={sortBy}
                        onChange={(e) => setSortBy(e.target.value)}
                        className="px-4 py-2.5 md:py-3 border border-[#E5E7EB] text-sm text-[#1A1A1A] focus:outline-none focus:border-[#2D6A4F] transition-colors bg-white"
                    >
                        {sortOptions.map(option => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                        ))}
                    </select>
                    <button
                        onClick={() => setShowFilters(!showFilters)}
                        className="inline-flex items-center justify-center gap-2 px-4 py-2.5 md:py-3 border border-[#E5E7EB] text-sm text-[#1A1A1A] hover:border-[#2D6A4F] transition-colors md:hidden"
                    >
                        <SlidersHorizontal size={16} /> Filters
                    </button>
                </div>

                {/* Mobile Filters Drawer */}
                {showFilters && (
                    <div className="fixed inset-0 z-50 md:hidden">
                        <div className="absolute inset-0 bg-black/40" onClick={() => setShowFilters(false)} />
                        <div className="absolute right-0 top-0 bottom-0 w-[300px] bg-white shadow-xl p-6 overflow-y-auto">
                            <div className="flex items-center justify-between mb-6">
                                <h3 className="text-lg font-semibold text-[#1A1A1A]">Filters</h3>
                                <button onClick={() => setShowFilters(false)}>
                                    <X size={20} className="text-[#6B7280]" />
                                </button>
                            </div>
                            <div className="space-y-6">
                                <div>
                                    <h4 className="text-sm font-medium text-[#1A1A1A] mb-3">Price Range</h4>
                                    <input
                                        type="range" min="0" max="50000"
                                        value={priceRange[1]}
                                        onChange={(e) => setPriceRange([0, parseInt(e.target.value)])}
                                        className="w-full accent-[#2D6A4F]"
                                    />
                                    <div className="flex justify-between text-xs text-[#6B7280] mt-1">
                                        <span>{'\u20B9'}0</span>
                                        <span>{'\u20B9'}{priceRange[1].toLocaleString('en-IN')}</span>
                                    </div>
                                </div>
                                <div>
                                    <h4 className="text-sm font-medium text-[#1A1A1A] mb-3">Size</h4>
                                    <div className="flex flex-wrap gap-2">
                                        {['XS', 'S', 'M', 'L', 'XL', 'XXL'].map(size => (
                                            <button key={size} className="px-3 py-2 text-xs border border-[#E5E7EB] hover:border-[#2D6A4F] hover:text-[#2D6A4F] transition-colors">
                                                {size}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                                <div>
                                    <h4 className="text-sm font-medium text-[#1A1A1A] mb-3">Fabric</h4>
                                    <div className="space-y-2">
                                        {['Silk', 'Cotton', 'Georgette', 'Velvet', 'Organza'].map(fabric => (
                                            <label key={fabric} className="flex items-center gap-2 text-sm text-[#6B7280]">
                                                <input type="checkbox" className="accent-[#2D6A4F]" />
                                                {fabric}
                                            </label>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="mt-8">
                                <Button variant="primary" fullWidth onClick={() => setShowFilters(false)}>
                                    Apply Filters
                                </Button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Category Tabs */}
                <div className="flex gap-2 md:gap-3 mb-6 md:mb-8 overflow-x-auto pb-2 -mx-4 px-4 md:mx-0 md:px-0 scrollbar-hide">
                    {categories.map(category => (
                        <button
                            key={category}
                            onClick={() => setSelectedCategory(category.toLowerCase())}
                            className={`px-4 md:px-6 py-2 text-xs md:text-sm font-medium transition-colors whitespace-nowrap ${
                                selectedCategory === category.toLowerCase()
                                    ? 'bg-[#2D6A4F] text-white'
                                    : 'bg-[#F8FAF8] text-[#1A1A1A] hover:bg-[#E5E7EB]'
                            }`}
                        >
                            {category}
                        </button>
                    ))}
                </div>

                {/* Products Grid */}
                <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-5 lg:grid-cols-4 lg:gap-6">
                    {filteredProducts.map(product => (
                        <ProductCard key={product.id} product={product} />
                    ))}
                </div>

                {/* Load More */}
                <div className="text-center mt-10 md:mt-14">
                    <Button variant="secondary" size="lg">
                        Load More Products
                    </Button>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Shop;
